import React, { useState } from 'react'
import api from '../api';
import { useAuth } from '../context/auth'
import { Button } from './FormStyle';
import { Link } from "react-router-dom";

export default function Logout() {

    const { authTokens, setAuthTokens } = useAuth();
    const [isError, setIsError] = useState(false);

  function handleLogout() {
        api
        .post("/api/users/logout")
        .then((result) => {
          if (result.status === 200) {
              setAuthTokens(null);
          } else {
            setIsError(true);
          }
        })
        .catch((e) => {
          setIsError(true);
        });
    }

    if (authTokens && authTokens.token != null) {
        return (
            <>
        <Button onClick={handleLogout}>Logout</Button>
            </>
        );
    } else {
        return null;
    }

}
